type Props = {
  loading: boolean;
  children: React.ReactNode;
};

export const FormOverlay = ({ loading, children }: Props) => (
  <div className="relative">
    {loading && <div className="absolute inset-0 bg-white/30 rounded-xl z-10 cursor-wait" />}
    {children}
  </div>
);
